import React, { useCallback } from 'react';
import { CaseStudyContentfulModel } from 'src/api/models/CaseStudy'
import {
  CoursesStoriesHeadingContainer,
  StoriesOfAwesomeContainer,
  StoriesOfAwesomeSection,
  StoryImage,
  StoryImageContainer,
  StoryImageOverlay,
  StoryInfoContainer,
  StoryItem,
  StoryTitle,
  StoriesSliderContainer
} from './courses.storiesOfAwesome.styles'
import { palette } from 'styles/colors';
import LinkBranded from 'elements/links/Link.branded'
import { LeftArrow, RightArrow } from 'src/molecules/courses/courses.carousel.styles'
import Slider from 'react-slick'
import Heading from 'elements/typography/heading'
import Paragraph from 'src/elements/typography/paragraph';

interface CoursesStoriesOfAwesomeProps {
  caseStudies: CaseStudyContentfulModel[]
}

const CoursesStoriesOfAwesome = ({ caseStudies }: CoursesStoriesOfAwesomeProps): JSX.Element => {

  const sliderSettings = {
    infinite: true,
    draggable: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 1000,
    responsive: [
      {
        breakpoint: 950, // layout.subLg
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 700, // layout.sm
        settings: {
          slidesToShow: 1
        }
      }
    ],
    nextArrow: <RightArrow />,
    prevArrow: <LeftArrow />,
  }

  const getCtaColorByIndex = useCallback((index: number) => {
    const colors = [ palette.snowFlower, palette.purple, palette.livingCoral ];
    return colors[ index % 3 ];
  }, []);

  return (
    <StoriesOfAwesomeSection>
      <StoriesOfAwesomeContainer>
        <CoursesStoriesHeadingContainer>
          <Heading
            align="center"
            size="2.5em"
            sizeLg="2em"
            sizeSubLg="1.5em"
            text="Stories of Awesome"
          />
          <Paragraph
            align="center"
            size="1.375em"
            sizeSubLg="1.1875em"
            weight="light"
            text="Read our case studies to learn how creators and brands are using online courses to build thriving businesses.
"
          />
        </CoursesStoriesHeadingContainer>
        <StoriesSliderContainer>
          <Slider {...sliderSettings}>
            {caseStudies.filter(cS => cS.heroImage?.gatsbyImageData).map((caseStudy, index) => (
              <StoryItem key={index}>
                <StoryImageContainer>
                  <StoryImageOverlay />
                  <StoryImage image={caseStudy.heroImage.gatsbyImageData} alt={caseStudy.title} objectFit="cover" />
                </StoryImageContainer>
                <StoryInfoContainer>
                  <StoryTitle
                  text={caseStudy.title}
                  size="1.375em"
                  sizeSm="1em"
                  align="center"
                  />
                  <LinkBranded
                  url={`/case-studies/${caseStudy.slug}`}
                  text="Read the Story"
                  justify="center"
                  captionJustify="center"
                  weight="bold"
                  backgroundColor={getCtaColorByIndex(index)}
                  />
                </StoryInfoContainer>
              </StoryItem>
            ))}
          </Slider>
        </StoriesSliderContainer>
      </StoriesOfAwesomeContainer>
    </StoriesOfAwesomeSection>
  );
};

export default CoursesStoriesOfAwesome;
